import { render, staticRenderFns } from "./ContentSpecs.vue?vue&type=template&id=00786fb2&"
import script from "./ContentSpecs.vue?vue&type=script&lang=js&"
export * from "./ContentSpecs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports